import Field from './Field';

const NumProps: string[] = [
  Field.PROPERTY_SIZE,
  Field.PROPERTY_ROWS,
  Field.PROPERTY_COLSPAN,
  Field.PROPERTY_ROWSPAN,
  Field.PROPERTY_PAGED_GRID_SIZE,
  Field.PROPERTY_GRID_HEIGHT,
  Field.PROPERTY_MAX_REG_GRID,
];

export default NumProps;
